import styled from 'styled-components';
import devices from 'src/viewLayer/styling/mixins/media-queries';
import { Box, Layout, Stack } from '@lessonnine/design-system.lib';
import tokens from '@lessonnine/design-tokens.lib/dist/json/variables.json';

export const CardLayout = styled(Layout)`
  background-color: ${({ theme }) => theme.color.surface.container.background};
`;

CardLayout.defaultProps = {
  theme: {
    color: {
      surface: {
        container: {
          background: 'transparent'
        }
      }
    }
  }
};

export const Card = styled(Box)`
  background-color: ${({ theme }) => theme.color.surface.layer.background};
  height: 100%;
  min-height: calc(100% - 4rem);
  position: relative;

  @media only screen and ${devices.fromsmall} {
    border-radius: 0 ${tokens.size.radius.large} ${tokens.size.radius.large} ${tokens.size.radius.large};
    box-shadow: 0 0 50px ${tokens.boxShadow.active.card};
    margin: 2rem auto;
    width: 35.625rem;
  }
`;

Card.defaultProps = {
  theme: {
    color: {
      surface: {
        layer: {
          background: 'transparent'
        }
      }
    }
  }
};

export const LoginBusinessPageWithBackground = styled.div`
  background-color: ${({ theme }) => theme.color.surface.layer.background};
  height: 100%;

  @media only screen and ${devices.fromsmall} {
    background-color: ${({ theme }) => theme.color.surface.container.background};
  }
`;

LoginBusinessPageWithBackground.defaultProps = {
  theme: {
    color: {
      surface: {
        container: {
          background: 'transparent'
        },
        layer: {
          background: 'transparent'
        }
      }
    }
  }
};

export const FormContainer = styled(Stack)`
  margin: auto 0;
  width: 100%;
`;
